import React, { Component } from 'react';
import Highcharts from 'react-highcharts';

class HighChartsCom extends Component {
    getChartConfig = () => {
        const { series, categories } = this.props;
        return {
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            yAxis: {
                title: {
                    text: ''
                },
                labels: {
                    formatter: function () {
                        var data = this.chart.series ? this.chart.series[0] : {};
                        if ((Object.keys(data).length > 0) && data.name !== '知情数' && data.name !== '筛选数' && data.name !== '随机(入组)数' && data.name !== '工时') {
                            return `${this.value.toFixed(2)}%`;
                        } else {
                            return this.value;
                        }
                    },
                },
            },
            tooltip: {
                formatter: function () {
                    if (this.series.name !== '知情数' && this.series.name !== '筛选数' && this.series.name !== '随机(入组)数' && this.series.name !== '工时') {
                        return `<p style="font-size:10px">${this.x}</p><br/>${this.series.name}:<b>${this.y.toFixed(2)}%</b>`
                    } else {
                        return `<p style="font-size:10px">${this.x}</p><br/>${this.series.name}:<b>${this.y}</b>`
                    }
                }
            },
            xAxis: {
                categories: categories
            },
            series: series,
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            plotOptions: {
                series: {
                    animation: false
                }
            },
            credits: {
                enabled: false,
                text: 'SMO医疗大数据',
            },
        };
    }

    render() {
        const { chartsConfig } = this.props;
        const config = this.getChartConfig();  
        return (
            <div><Highcharts config={{ ...config, ...chartsConfig }} /></div>
        );
    }
}

export default HighChartsCom;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/HighChartsCom.js